export const devextremeLicenseKey =
    "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjk3YzMyYjFiLTM4ZDAtNDU4NS04M2RkLTU3ZmI0Mzc3YjIyMyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.jOKGD0G9+tDS2L8M621IH3t0LNCE9FZ7ZCm3ZpZXujC8eaNvnXko8HWZx2ypYehcqzgSuo39iT6FtoYE0XrVCaGUT6EMr/0OkmXCiKe8Fu/MNseycqLnjPD4RwMATWsHZQaeyg==";
